import React, {useRef, useState} from "react";
import {useDispatch} from "react-redux";
import PageHeader from "../../../components/Elements/pageHeader";
import {
    DefaultTablePagination,
    Table,
} from "../../../components/Elements/appUtils";
import moment from "moment";
import {getVisitFollowupsFxn} from "../actions";

const VisitFollowUp = (props) => {
    let tableRef = useRef();
    let [total, setTotal] = useState(0)
    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            const data = await getVisitFollowupsFxn(params);
            setTotal(data.total || 0)
            resolve(data);
        });
    };

    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },

        {
            title: "Patient",
            dataIndex: "patientId",
            key: "patientId",
            render: (text, record) => {
                return (
                    <div>
                        {record.patientName} (ID : {record.uhid || ""})<br/>
                        Gender : {record.gender} (Age : {record.age})<br/>
                        Mobile : {record.mobile}<br/>
                        Address : {record.city}, {record.state}, {record.country}
                    </div>
                )
            },
        },
        {
            title: "Visit",
            dataIndex: "date",
            key: "date",
            width: 200,
            render: (text, record) => {
                let {time, visitNumber} = record;
                return (
                    <div>
                        <span>{moment(record.date).format("DD/MM/YYYY")}, {moment(time).format("hh:mm A")} </span><br/>
                        Visit No : {visitNumber}
                    </div>
                )
            }
        },
        {
            title: "Balance",
            dataIndex: "balance",
            key: "balance",
            render: (item) => {
                return item !== undefined ? item && item.toFixed(2) : 0
            }
        },
    ];
    return (
        <>
            <PageHeader title={(
                <div>
                    Visits Follow up <small style={{fontSize: 12}}>(Total : {total})</small>
                </div>
            )}>
                <div className="card">
                    <div className="card-body">
                        <Table
                            apiRequest={apiRequest}
                            columns={columns}
                            pagination={{
                                ...DefaultTablePagination(),
                                defaultPageSize: 5,
                                pageSizeOptions: ["5", "10", "25", "50", '100']
                            }}
                            ref={tableRef}/>
                    </div>
                </div>
            </PageHeader>
        </>
    );
};

export default VisitFollowUp;
